import React from 'react';
import Login from '../Sign-Up/Login'
import ScrollToTopOnMount from '../../ScrollToTopOnMount';
const Signin = () => {
  return (
    <div>
      <ScrollToTopOnMount />
      <Login />
    </div>
  )
}

export default Signin
